<template>
  <v-dialog :value="true" width="95%" persistent scrollable :fullscreen="true">
    <v-card>
      <v-card-title class="text-h3 primary--text"
        >CARGAR MUESTRAS EXCEL</v-card-title
      >
      <v-card-text>
        <v-layout row>
          <v-flex xs12>
            <v-tabs
              background-color="transparent"
              v-model="tab"
              class="transparent"
            >
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab>
                Muestras
              </v-tab>
              <v-tab>
                Información Adicional
              </v-tab>
            </v-tabs>
          </v-flex>
        </v-layout>
        <v-layout row v-show="tab === 0">
          <v-flex xs12>
            <v-simple-table fixed-header height="70vh">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th width="50" class="text-left primary--text"></th>
                    <th class="text-left primary--text">
                      Código Barras
                    </th>
                    <th class="text-left primary--text">
                      Tipo Análisis
                    </th>
                    <th class="text-left primary--text">
                      Paciente
                    </th>
                    <th class="text-left primary--text">
                      Resultado
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="m in muestras" :key="m.Codigo">
                    <td width="50">
                      <v-icon color="primary" v-if="m.EsCorrect === 1"
                        >done</v-icon
                      >
                      <v-icon color="error" v-if="m.EsCorrect === 0"
                        >close</v-icon
                      >
                    </td>
                    <td>
                      {{ m.CodigoBarras }}
                    </td>
                    <td>{{ m.AnalisisTipo }}</td>
                    <td>{{ m.Paciente }}</td>
                    <td v-html="m.Resultado"></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-container grid-list-md v-show="tab === 1">
          <v-form ref="formInfo">
            <v-layout row wrap class="mt-2">
              <v-flex xs12 md6>
                <v-layout row wrap>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Tipo de Cita:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-autocomplete
                      :rules="[() => !!info.AgendaTipoID || 'Campo requerido']"
                      hide-details="auto"
                      :items="catalogos.AgendaTipos"
                      item-text="Agenda"
                      item-value="AgendaTipoID"
                      v-model="info.AgendaTipoID"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Responsable de Muestra
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-autocomplete
                      :rules="[() => !!info.Enfermera || 'Campo requerido']"
                      hide-details="auto"
                      :items="catalogos.Enfermeras"
                      item-text="Nombre"
                      return-object
                      v-model="info.Enfermera"
                      :append-outer-icon="'date_range'"
                      @click:append-outer="abrirCalendario"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Correo Resultados
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :rules="[
                        () =>
                          validarEmail(info.CorreoResultados) ||
                          'Ingrese un correo válido',
                      ]"
                      v-model="info.CorreoResultados"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="text-h5 pt-4 pl-5">
                    Forma de pago
                  </v-flex>
                  <v-flex xs12
                    ><v-radio-group
                      :rules="[
                        () => info.PagoTipoID !== -1 || 'Campo requerido',
                      ]"
                      v-model="info.PagoTipoID"
                    >
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          md4
                          v-for="tp in catalogos.PagosTipos"
                          :key="tp.PagoTipoID"
                        >
                          <v-radio
                            :label="tp.Pago"
                            :value="tp.PagoTipoID"
                          ></v-radio>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-flex>
                  <template v-if="info.PagoTipoID === 5">
                    <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                      Convenio
                    </v-flex>
                    <v-flex xs12 md9 class="pr-5">
                      <v-text-field
                        v-model="info.ConvenioNombre"
                        :rules="[
                          () => !!info.ConvenioNombre || 'Campo requerido',
                        ]"
                      ></v-text-field>
                    </v-flex>
                  </template>
                  <v-flex xs12 md12 class="text-h5 pt-4 pl-5">
                    <v-checkbox
                      label="Requiere Factura"
                      v-model="info.RequiereFactura"
                    >
                    </v-checkbox>
                  </v-flex>
                  <template v-if="info.RequiereFactura">
                    <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                      Razón Social:
                    </v-flex>
                    <v-flex xs12 md9 class="pr-5">
                      <v-text-field
                        :rules="[
                          () =>
                            !info.RequiereFactura ||
                            !!info.RazonSocial ||
                            'Campo requerido',
                        ]"
                        v-model="info.RazonSocial"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                      RFC:
                    </v-flex>
                    <v-flex xs12 md9 class="pr-5">
                      <v-text-field
                        :rules="[
                          () =>
                            !info.RequiereFactura ||
                            !!info.RFC ||
                            'Campo requerido',
                        ]"
                        v-model="info.RFC"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                      Domicilio Fiscal:
                    </v-flex>
                    <v-flex xs12 md9 class="pr-5">
                      <v-text-field
                        :rules="[
                          () =>
                            !info.RequiereFactura ||
                            !!info.DomicilioFiscal ||
                            'Campo requerido',
                        ]"
                        v-model="info.DomicilioFiscal"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                      Correo Factura:
                    </v-flex>
                    <v-flex xs12 md9 class="pr-5">
                      <v-text-field
                        :rules="[
                          () =>
                            !info.RequiereFactura ||
                            validarEmail(info.CorreoFactura) ||
                            'Ingrese un correo válido',
                        ]"
                        v-model="info.CorreoFactura"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>
              <v-flex xs12 md6>
                <v-layout row wrap>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Fecha de la toma:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <datepicker
                      v-model="info.FechaMuestra"
                      :rules="[() => !!info.FechaMuestra || 'Campo requerido']"
                    ></datepicker>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Hora:
                  </v-flex>
                  <v-flex xs12 md5 class="pr-5">
                    <timepicker
                      v-model="info.HoraMuestra"
                      :rules="[() => !!info.HoraMuestra || 'Campo requerido']"
                    ></timepicker>
                  </v-flex>
                  <v-flex xs12 md4 class="pr-5">
                    <v-checkbox
                      v-model="info.EsUrgente"
                      label="Urgente"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    ¿Padece alguna enfermedad?
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-radio-group
                      row
                      :rules="[
                        () =>
                          info.PadeceEnfermedad != null || 'Campo requerido',
                      ]"
                      v-model="info.PadeceEnfermedad"
                    >
                      <v-radio label="Si" :value="true"></v-radio>
                      <v-radio label="No" class="ml-2" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <template v-if="info.PadeceEnfermedad">
                    <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                      ¿Cuál?
                    </v-flex>
                    <v-flex xs12 md9 class="pr-5">
                      <v-text-field
                        v-model="info.CualEnfermedad"
                        :rules="[
                          () => !!info.CualEnfermedad || 'Campo requerido',
                        ]"
                      ></v-text-field>
                    </v-flex>
                  </template>
                  <v-flex xs12 class="text-h5 pt-4 pl-5">
                    La solicitud es por indicación personal o médica:
                  </v-flex>
                  <v-flex xs12 class="pl-5">
                    <v-radio-group
                      row
                      :rules="[
                        () =>
                          info.EsIndicacionMedica != null || 'Campo requerido',
                      ]"
                      v-model="info.EsIndicacionMedica"
                    >
                      <v-radio label="Personal" :value="false"></v-radio>
                      <v-radio
                        label="Médica"
                        class="ml-2"
                        :value="true"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn class="mr-5" text @click.prevent="cerrar(false)">
          Cancelar</v-btn
        >
        <v-spacer> </v-spacer>
        <span class="ml-3">
          <span class="primary--text font-weight-bold">REGISTROS:</span>
          {{ detalles.CantidadRegistros }}
        </span>
        <span class="ml-3">
          <span class="primary--text font-weight-bold">CORRECTOS:</span>
          {{ detalles.CantidadCorrectos }}
        </span>
        <span class="ml-3 mr-5">
          <span class="primary--text font-weight-bold">INCORRECTOS:</span>
          {{ detalles.CantidadIncorrectos }}
        </span>
        <v-btn color="primary" class="mr-5" @click.prevent="cargar" :disabled="Desactivar"
          ><v-icon>save</v-icon> Cargar Muestras</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ServicioMuestras from "../services/muestras";
import datepicker from "../components/DatePicker.vue";
import timepicker from "../components/TimePicker";
import ServicioCatalogos from "../services/catalogos";
export default {
  name: "muestrasExcel",
  components: { datepicker, timepicker },
  props: ["datos"],
  data() {
    return {
      muestras: [],
      Desactivar: false,
      detalles: {},
      tab: 0,
      info: {},
      catalogos: { Enfermeras: [], PagosTipos: [], AgendaTipos: [] },
    };
  },
  async mounted() {
    await this.cargarCatalogos();
    if (this.datos) {
      this.muestras = this.datos.Table0;
      this.detalles = this.datos.Table1[0];
    }
  },
  methods: {
    async cargarCatalogos() {
      let res = await ServicioCatalogos.getPagosTipos();
      this.catalogos.PagosTipos = res.data.data.Table0;
      res = await ServicioCatalogos.getEnfermeras();
      this.catalogos.Enfermeras = res.data.data.Table0;
      res = await ServicioCatalogos.getAgendaTipos();
      this.catalogos.AgendaTipos = res.data.data.Table0.filter(
        (at) => at.AgendaTipoID === 3 || at.AgendaTipoID === 4
      );
    },
    abrirCalendario() {},
    async cargar() {
      if (this.$refs.formInfo.validate()) {

        this.Desactivar = true;

        const data = {
          MuestraExcelID: this.detalles.MuestraExcelID,
          Enfermera_UsuarioID: this.info.Enfermera.Enfermera_UsuarioID,
          CorreoResultados: this.info.CorreoResultados,
          PagoTipoID: this.info.PagoTipoID,
          ConvenioNombre: this.info.ConvenioNombre,
          RequiereFactura: !!this.info.RequiereFactura,
          RFC: this.info.RFC,
          RazonSocial: this.info.RazonSocial,
          DomicilioFiscal: this.info.DomicilioFiscal,
          CorreoFactura: this.info.CorreoFactura,
          FechaMuestra: `${this.info.FechaMuestra}T${this.info.HoraMuestra}`,
          EsUrgente: this.info.EsUrgente,
          PadeceEnfermedad: this.info.PadeceEnfermedad,
          CualEnfermedad: this.info.CualEnfermedad,
          EsIndicacionMedica: this.info.EsIndicacionMedica,
          AgendaTipoID: this.info.AgendaTipoID,
        };
        const res = await ServicioMuestras.procesarCargaManual(data);
        if (res.data.result === 1) {
          this.$root.mensajeExito = "Las muestras se procesaron correctamente.";
          this.cerrar(true);

          this.Desactivar = false;
        } else {
          this.$root.mensajeError = res.data.message;
          
          this.Desactivar = false;
        }
      } else {
        this.$root.mensajeError = "Por favor llene los campos requeridos.";
        this.tab = 1;
      }
    },
    cerrar(recargar) {
      this.$emit("cerrar", recargar);
    },
  },
};
</script>
